<template>
  <div>
    <b-card>
      <b-row>
        <div class="col-lg-5">
          <div class="d-flex w-100 border-bottom pb-2 label-header mb-3">
            <label class="mb-0">Wallet Information</label>
            <!-- <div class="d-flex ms-auto" :class="{ 'pe-none': peddlrWalletDetails.cognito_sub == null }" @click="$router.push({ path: `/customer/profile-information/Profile/${businessId}/peddlr-wallet/edit-limit`, })"
               :disabled="peddlrWalletDetails.cognito_sub == null">
              <i class="bx bx-edit-alt pe-1" :class="{ 'text-muted': peddlrWalletDetails.cognito_sub == null }"></i>
              <b-link class="ms-auto text-decoration-underline" :class="{ 'text-muted': peddlrWalletDetails.cognito_sub == null }">
                Edit Wallet
              </b-link>
            </div> -->
            <div class="d-flex ms-auto">
              <b-button variant="link" @click="generateQR"
                :class="{ 'text-muted pe-none': peddlrWalletDetails.cognito_sub == null }" :disabled="peddlrWalletDetails.cognito_sub == null">
                <i class="mdi mdi-qrcode-scan text-decoration-underline"></i>
                <span class="text-decoration-underline">
                  Generate QR
                </span>
              </b-button>
              <b-button variant="link"
                :class="{ 'text-muted pe-none': peddlrWalletDetails.cognito_sub == null }" :disabled="peddlrWalletDetails.cognito_sub == null"
                @click="$router.push({ path: `/customer/profile-information/Profile/${businessId}/peddlr-wallet/edit-limit`, })">
                <span class="text-decoration-underline">
                  <i class="bx bx-pencil text-decoration-underline"></i>
                  Edit Wallet
                </span>
              </b-button>
            </div>
          </div>
          <div class="d-flex flex-wrap">
            <div class="d-flex mb-3 col-lg-6">
              <i class="mdi mdi-wallet me-2" style="margin-top: 6px;"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Peddlr Wallet</p>
                <label class="mb-1" :class="{ 'text-muted': !peddlrWalletDetails.cognito_sub }">₱{{ peddlrWalletDetails.availableBalance ? peddlrWalletDetails.availableBalance.toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00'  }}</label>
              </div>
            </div>
            <div class="d-flex mb-3 col-lg-6">
              <i class="bx bx-globe me-2" style="margin-top: 12px;"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Wallet Address</p>
                <label class="mb-1" v-if="peddlrWalletDetails.acct_no">{{ peddlrWalletDetails.acct_no }}</label>
                  <label class="text-danger" v-else>No existing Peddlr Wallet</label>
              </div>
            </div>
            <div class="d-flex mb-3 col-lg-6">
              <i class="bx bx-user-circle me-2" style="margin-top: 12px;"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Store Owner</p>
                <label class="mb-1">{{ businessDetails.subscriberName ? businessDetails.subscriberName : businessDetails.businessId }}</label>
              </div>
            </div>
            <div class="d-flex mb-3 col-lg-6">
              <i class="bx bx-store-alt me-2" style="margin-top: 12px;"></i>
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Business Name</p>
                <label class="mb-1">{{ businessDetails.businessName }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-7">
          <label class="w-100 border-bottom pb-2 label-header mb-3">Financial Overview</label>
          <div class="d-flex flex-wrap">
            <div class="d-flex align-items-center mb-3 col-lg-5">
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Monthly Incoming</p>
                <label class="mb-1">₱{{ peddlrWalletDetails.monthly_incoming ? peddlrWalletDetails.monthly_incoming.toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00'  }}</label>
              </div>
            </div>
            <div class="d-flex align-items-center mb-3 col-lg-5">
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Monthly Outgoing</p>
                <label class="mb-1">₱{{ peddlrWalletDetails.monthly_outgoing ? peddlrWalletDetails.monthly_outgoing.toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00'  }}</label>
              </div>
            </div>
            <div class="d-flex align-items-center mb-3 col-lg-5">
              <div class="d-flex flex-column">
                <p class="mb-1 fs-13px">Daily Incoming</p>
                <label class="mb-1">₱{{ peddlrWalletDetails.daily_incoming ? peddlrWalletDetails.daily_incoming.toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00'  }}</label>
                <p class="mb-1 fs-13px">as of {{ peddlrWalletDetails.daily_incoming_datetime ? peddlrWalletDetails.daily_incoming_datetime : new Date() | formatDate }}</p>
              </div>
            </div>
            <div class="d-flex align-items-center mb-3 col-lg-5">
              <div class="d-flex flex-column">
                <label class="mb-1">Daily Outgoing</label>
                <label class="mb-1">₱{{ peddlrWalletDetails.daily_outgoing ? peddlrWalletDetails.daily_outgoing.toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00'  }}</label>
                <p class="mb-1 fs-13px">as of {{ peddlrWalletDetails.daily_outgoing_datetime ? peddlrWalletDetails.daily_outgoing_datetime : new Date() | formatDate }}</p>
              </div>
            </div>
          </div>
        </div>
      </b-row>
    </b-card>
    <!-- Table Card-->
    <b-card>
      <div class="d-flex align-items-center mb-4">
        <h5 class="mb-0">{{ peddlrWalletTxnTotal }} Record(s)</h5>
        <button class="btn btn-secondary ms-auto" @click="getTransactions()">
          <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp; Refresh
        </button>
      </div>

      <div class="d-flex flex-wrap mb-4">
        <div class="ta-right me-3">
          <b-form-group description="Search Keyword">
            <div class="d-flex">
              <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width: fit-content"
                    id="input-3" v-model="search.field" :options="searchFields"></b-form-select>
              <b-form-input class="rounded-0 rounded-end" v-model="search.keyword" @keyup.enter="getTransactions()"></b-form-input>
            </div>
          </b-form-group>
        </div>
        <div class="ta-right me-3">
          <b-form-group description="Filter by Status">
            <b-form-select class="form-select rounded shadow-none status-form-select"
              v-model="search.status"
              :options="statusOptions"
            ></b-form-select>
          </b-form-group>
        </div>
        <div class="ta-right me-3">
          <b-form-group description="Filter by Transaction Date">
            <flat-pickr
              v-model="search.dateRange"
              :config="rangeOptions"
              placeholder="Select a date range"
              class="form-control"
              style="width: fit-content"
            ></flat-pickr>
          </b-form-group>
        </div>
        <button type="button" class="btn btn-primary h-fit me-3" @click="isSearching = true; getTransactions()">
          <i class='bx bx-search bx-fw'></i>Search
        </button>
        <button class="btn btn-primary h-fit" @click="onExport()">
          <i class="uil uil-export me-1"></i>Export
        </button>
      </div>

      <!-- Table -->
      <div class="table-responsive">
        <div class="table align-middle table-nowrap">
          <b-table
            :fields="tableFields"
            :items="peddlrWalletTxn"
            responsive="sm"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="table-check"
            @sort-changed="tableSorting">

            <template #cell(trans_type)="data">
              <div>{{ data.item.trans_type.charAt(0).toUpperCase() + data.item.trans_type.slice(1) }}</div>
            </template>

            <template #cell(status)="data">
              <div :class="{
                'success': data.item.status == 'successful',
                'failed': data.item.status == 'failed',
                'processing': data.item.status == 'processing'
              }">
                {{ data.item.status.charAt(0).toUpperCase() + data.item.status.slice(1) }}</div>
            </template>

            <template #cell(total_amount)="data">
              <div>₱{{ data.item.total_amount ? data.item.total_amount.toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00' }}</div>
            </template>

            <template #cell(transaction_amount)="data">
              <div>₱{{ data.item.transaction_amount ? data.item.transaction_amount.toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00' }}</div>
            </template>

            <template #cell(mdr_fees)="data">
              <div>₱{{ data.item.mdr_fees ? data.item.mdr_fees.toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00' }}</div>
            </template>

            <template #cell(total_convenience_fee)="data">
              <div>₱{{ data.item.total_convenience_fee ? data.item.total_convenience_fee.toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00' }}</div>
            </template>

            <template #cell(merchant_share)="data">
              <div>₱{{ data.item.merchant_share ? data.item.merchant_share.toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00' }}</div>
            </template>

            <template #cell(peddlr_share)="data">
              <div>₱{{ data.item.peddlr_share ? data.item.peddlr_share.toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00' }}</div>
            </template>

            <template #cell(netbank_share)="data">
              <div>₱{{ data.item.netbank_share ? data.item.netbank_share.toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00' }}</div>
            </template>

            <template #cell(transaction_fee)="data">
              <div>₱{{ data.item.transaction_fee ? data.item.transaction_fee.toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00' }}</div>
            </template>

            <!-- <template #cell(amount)="data">
              <div>₱{{ data.item.amount ? data.item.amount.toLocaleString(undefined, {minimumFractionDigits: 2}) : '0.00' }}</div>
            </template> -->

            <template #cell(trans_datetime)="data">
              <div>{{ data.item.trans_datetime | formatDate }}</div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="row g-0 text-center" v-if="!peddlrWalletTxnTotal">
        <span>No data to display.</span>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group d-flex align-items-center" v-if="peddlrWalletTxnTotal">
            <label class="me-4 mb-0">Display:</label>
            <b-form-group label-for="display-record">
              <b-form-select class="form-select shadow-none w-fit"
                id="display-record"
                v-model="perPage"
                :options="pageOptions"
                @change="getTransactions()"
              ></b-form-select>
            </b-form-group>
          </div>
        </div>

        <!-- pagination -->
        <div class="col-lg-6">
          <div class="dataTables_paginate paging_simple_numbers float-end" v-if="peddlrWalletTxnTotal > perPage" >
            <b-pagination
              class="pagination-rounded"
              v-model="currentPage"
              :total-rows="peddlrWalletTxnTotal"
              @input="getTransactions()"
              :per-page="perPage"
            ></b-pagination>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import appConfig from "@/app.config";
// import { required } from "vuelidate/lib/validators";
import { customerMethods, customerListComputed, peddlrWalletMethods, peddlrWalletComputed, layoutMethods, exportMethods } from "@/state/helpers";
import Swal from 'sweetalert2';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  page: {
    title: "Peddlr Wallet Transactions",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      businessId: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      sortBy: "t.id",
      sortDesc: true,
      search: {
        field: null,
        keyword: "",
        status: null,
        dateRange: null,
      },
      searchFields: [
        { text: "Search All", value: null },
        { text: "Transaction ID", value: "t.transaction_id" },
        { text: "Account Name", value: "t.acct_name" },
        { text: "Account Number", value: "t.acct_no" },
      ],
      statusOptions: [
        { text: "All", value: null },
        { text: "Processing", value: "processing" },
        { text: "Successful", value: "successful" },
        { text: "Failed", value: "failed" },
      ],
      rangeOptions: {
        mode: "range",
      },
      tableFields: [
        { key: "transaction_id", label: "Transaction ID", sortable: true, },
        { key: "acct_name", label: "Account Name", sortable: true, },
        { key: "acct_no", label: "Account Number", sortable: true, },
        { key: "trans_type", label: "Transaction Type", sortable: true, },
        { key: "bank_name", sortable: true, },
        { key: "status", label: "Payment Status", sortable: true, },
        { key: "total_amount", label: "Total Amount", sortable: true, },
        { key: "transaction_amount", label: "Transaction Amount", sortable: true, },
        { key: "mdr_fees", label: "MDR Fee", sortable: true, },
        { key: "total_convenience_fee", label: "Kolek Fee", sortable: true, },
        { key: "merchant_share", label: "Merchant Kita", sortable: true, },
        { key: "peddlr_share", label: "Peddlr Share", sortable: true, },
        { key: "netbank_share", label: "Netbank Share", sortable: true, },
        { key: "transaction_fee", label: "Instapay Fee", sortable: true, },
        // { key: "amount", label: "Merchant Sales", sortable: true, },
        { key: "trans_datetime", label: "Date", sortable: true, },
      ],
      isSearching: false,
    };
  },
  components: {
    flatPickr,
  },
  computed: {
    ...customerListComputed,
    ...peddlrWalletComputed,
  },
  mounted() {
    this.businessId = this.$route.params.bid;
    this.changeTitle({ title: "Peddlr Wallet Transactions" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Merchant List", to: { name: "Subscriber" } },
        { text: "Merchant Detail", to: { name: "Merchant Detail" } },
        { text: "Peddlr Wallet Transactions", to: { name: "Merchant Detail" } },
      ],
    });
    this.getBusinessDetails({ id: this.businessId });
    this.getPeddlrWalletDetails({ businessId: this.businessId });
    this.getTransactions();
  },
  methods: {
    ...layoutMethods,
    ...customerMethods,
    ...peddlrWalletMethods,
    ...exportMethods,
    async generateQR(){
      await this.getUserKankolekQR().then((res)=>{
        console.log("generateQR",res);
        Swal.fire({
          title: `Generated Static QR`,
          html: `
            <img id="qrImage" class="img-fluid w-100 qr-img" src="data:image/png;base64,${this?.businessQr?.generatedQRPH ?? null}">
          `,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonColor: "#E73092",
          confirmButtonText: `Download QR`,
          cancelButtonText: `Close`,
        }).then((result) => {
          if (result.isConfirmed) {
            // Extract the image data URL
            const image = document.getElementById('qrImage');
            const imageUrl = image.src;
            // Create a temporary download link
            const link = document.createElement('a');
            link.href = imageUrl;
            link.download = `qr-code (${this?.businessDetails?.businessName.trim()}).png`; // Set the desired file name
            document.body.appendChild(link); // Append the link to the document
            link.click(); // Trigger a click to start the download
            document.body.removeChild(link); // Remove the link from the document
            Swal.fire("QR Downloaded", `The QR code for ${this?.businessDetails?.businessName.trim()} has been successfully downloaded.`, "success");
          }
        }).catch((err)=>{
          console.log("Error generating QR",err)
          Swal.fire("Unable to generate QR", "", "error");
        });
      });
    },
    async getTransactions() {
      let params = {
        businessId: this.businessId,
        search: this.search,
        page: this.isSearching ? 1 : this.currentPage,
        limit: this.isSearching ? 10 : this.perPage,
        sortBy: this.sortBy,
        sortOrder: this.sortDesc ? 'DESC' : 'ASC'
      }

      this.getPeddlrWalletTxn(params)
        .then(() => {
          this.isSearching = false;
        });
    },
    async tableSorting(action) {
      let column = "";
      switch(action.sortBy) {
        case 'transaction_id' :
          column = 't.transaction_id';
          break;
        case 'acct_name' :
          column = 't.acct_name';
          break;
        case 'acct_no' :
          column = 't.acct_no';
          break;
        case 'trans_type' :
          column = 't.trans_type';
          break;
        case 'status' :
          column = 't.status';
          break;
        case 'service_fee' :
          column = 't.service_fee';
          break;
        case 'trans_datetime' :
          column = 't.trans_datetime';
          break;
        case 'transaction_fee' :
          column = 't.transaction_fee';
          break;
        case 'amount' :
          column = 't.amount';
          break;
        case 'total_convenience_fee' :
          column = 't.total_convenience_fee';
          break;
        case 'merchant_share' :
          column = 't.merchant_share';
          break;
        case 'peddlr_share' :
          column = 't.peddlr_share';
          break;
        case 'total_amount' :
          column = '(t.amount + t.transaction_fee)';
          break;
        case 'transaction_amount' :
          column = '(t.amount - (t.merchant_share + t.peddlr_share + t.netbank_share))';
          break;
        case 'mdr_fees' :
          column = 't.mdr_fees';
          break;
      }
      this.isSearching = true;
      this.sortBy = column;
      this.sortDesc = action.sortDesc;
      await this.getTransactions();
    },
    async onExport(){
      if(this.peddlrWalletTxnTotal == 0){
        Swal.fire("Export Cannot Proceed!", "No record(s) to export.", "info");
        return;
      }

      let params = {
        module: "peddlr_wallet_txn",
        businessId: this.businessId,
        email: JSON.parse(localStorage.getItem("userData")).email,
        search: {
          field: this.search.field,
          keyword: this.search.keyword,
          status: this.search.status,
          dateRange: this.search.dateRange,
        },
        sortBy: this.isSearching ? "" : this.sortBy,
        sortOrder: this.isSearching ? "DESC" : this.sortDesc ? "DESC" : "ASC" ,
      };
      
      this.exportReportExt(params)
        .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
        .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
    },
  },
};
</script>

<style>
.mdi-wallet,
.bx-globe,
.bx-user-circle,
.bx-store-alt {
  font-size: 25px;
  color: #7f4697;
}

.bx-edit-alt {
  font-size: 19px;
  margin-top: 3px;
  color: #E73092;
  cursor: pointer;
}

.label-header {
  font-size: 16px;
}

.me-5rem {
  margin-right: 5rem !important;
}

.fs-13px {
  font-size: 13px;
}

.fo-content-width {
  width: 250px;
}

.status-form-select {
  width: 170px;
}

.success {
  color: #508F30;
}

.failed {
  color: #C12928;
}

.processing {
  color: #F7CC53;
}
</style>
